import * as React from "react";
import corporateLogo from "../../assets/corporate_logo.svg";
import { EnvTag, envTagValue } from "../molecules/env-tag";

export const LoginTemplate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="c-content-wrapper">
      <div
        className="columns is-centered is-vcentered"
        style={{
          marginTop: "auto",
          marginBottom: "auto",
        }}
      >
        <div
          className="column is-4-desktop"
          style={{
            maxWidth: "520px",
          }}
        >
          <div
            className="box"
            style={{
              borderRadius: 0,
              padding: "36px",
            }}
          >
            <p className="has-text-centered">
              <img
                src={corporateLogo}
                alt="株式会社グラファー 会社ロゴ"
                style={{
                  width: "120px",
                }}
              />
            </p>
            {envTagValue && (
              <p className="has-text-centered has-text-weight-bold">
                <EnvTag />
              </p>
            )}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
